const lateStages = ['series-d', 'series-e', 'series-f', 'series-g', 'series-h', 'series-i', 'series-j']

function getCoverageStages(stages) {
    let hasLateStage = false;
    let newStages = [];
    for (let i = 0; i < stages.length; i++) {
      if (lateStages.includes(stages[i].type) && !hasLateStage) {
        hasLateStage = true;
      } else {
        newStages.push(stages[i]);
      }
    }
    if (hasLateStage) {
      newStages.push({
        id: Math.floor(Math.random() * 10**8),
        name: 'Late Stage',
        type: 'late-stage',
        uuid: Math.floor(Math.random() * 10**8)
      });
    }
    return newStages;
  }

  export default getCoverageStages;